var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.96 24.646l-3.193-2.578a1.232 1.232 0 00-1.741 0 1.352 1.352 0 000 1.905l2.65 3.037a1.642 1.642 0 002.34 0 1.685 1.685 0 000-2.364h-.056z",
    fill: "#BDBDBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.722 6C9.487 6 6 9.479 6 13.837c0 4.36 3.487 7.838 7.722 7.838s7.722-3.479 7.722-7.838a7.897 7.897 0 00-2.273-5.553A7.665 7.665 0 0013.722 6zM3 13.837C3 7.852 7.8 3 13.722 3c2.844 0 5.57 1.142 7.582 3.174a10.897 10.897 0 013.14 7.663c0 5.986-4.8 10.838-10.722 10.838S3 19.823 3 13.837z",
    fill: "#BDBDBD"
  })));
}

export default SvgSearchIcon;